/** Preserve the complete administrator canvas on every display size. */
export function displayLayoutScale(
  viewport: { width: number; height: number },
  canvas: { width: number; height: number },
): number {
  const values = [viewport.width, viewport.height, canvas.width, canvas.height];
  if (values.some((value) => !Number.isFinite(value) || value <= 0)) return 1;
  return Math.min(
    viewport.width / canvas.width,
    viewport.height / canvas.height,
  );
}
